import React from 'react'
import PropTypes from 'prop-types'
import ProgressBar from '../elements/ProgressBar'
import globals from '../globals'
import UnlimitedBar from '../elements/UnlimitedBar'

const BarChartUnlimited = (props) => {
    const Summary = () => {
        const text = props.item.summaryText.replace('/Unlimited', '')

        if (text.includes('$')) {
            return globals.addDecimals(text, true)
        }

        return text
    }

    return (
        <div className='bar-chart-wrapper'>
            <div className='row mb-2'>
                <div className='col-12 col-lg-8 mb-1 mb-lg-0'>
                    {!props.isUnlimited && <span className='d-none d-lg-inline'>
                        <span className='bold'>{props.item.title}:</span> {props.item.usageDescription ? props.item.usageDescription : `${Summary()} used`}
                    </span>}
                    <span className='d-lg-none'>
                        <span className='bold'>{props.item.title}:</span>
                    </span>
                </div>
                <div className='col-12 col-lg-4 text-lg-right'>
                    <span className='d-none d-lg-inline'>Unlimited</span>
                    <span className='d-lg-none'>{Summary()} / Unlimited</span>
                </div>
            </div>
            <div className='row d-none d-lg-flex'>
                <div className='col-12'>
                    <UnlimitedBar />
                </div>
            </div>
        </div>
    )
}

BarChartUnlimited.propTypes = {
    item: PropTypes.shape({
        summaryText: PropTypes.string.isRequired,
        unit: PropTypes.string.isRequired,
        title: PropTypes.string.isRequired,
        type: PropTypes.string
    }).isRequired
}

export default BarChartUnlimited



// WEBPACK FOOTER //
// ./resources/js/components/BarChartUnlimited.js